export const screenPath = '/ReactMyAccountHome/';
export const screenName = 'Home';
